import { ApiType } from "@gymflow/common";
import { PaymentMethodDTO } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { memberQueryKeys } from "./memberQueryKeys";

export function useQueryMemberPaymentMethodListNew(
  {
    api,
    memberId,
    clubId,
  }: {
    api: ApiType;
    memberId: string;
    clubId: number;
  },
  queryOpts?: Omit<UseQueryOptions<PaymentMethodDTO[]>, "queryKey">,
) {
  const result = useQuery({
    queryKey: memberQueryKeys.paymentMethodsNew(clubId, memberId),
    queryFn: async () => {
      const result = await api.memberApi.fetchPaymentMethods(memberId, clubId);
      return result.data;
    },
    ...queryOpts,
  });
  return result;
}
